import http from '@/api/http'
import { AxiosRequestConfig } from 'axios'

export default {
  fetchTimeline(params) {
    return new Promise((resolve, reject) => {
      http
        .post('/timeline/', params)
        .then(res => resolve(res.data))
        .catch(reject)
    })
  },

  toggleIine(t_id: string): Promise<any> {
    return new Promise((resolve, reject) => {
      http
        .post('/timeline/', {
          page: 'toggle_iine',
          t_id: t_id
        })
        .then(res => {
          resolve(res.data)
        })
        .catch(reject)
    })
  },

  post(fd: FormData, config?: AxiosRequestConfig): Promise<any> {
    return new Promise((resolve, reject) => {
      http
        .post('/timeline/', fd, config)
        .then(res => resolve(res.data))
        .catch(reject)
    })
  },

  remove(params): Promise<any> {
    return new Promise((resolve, reject) => {
      http
        .post('/timeline/', params)
        .then(res => resolve(res.data))
        .catch(reject)
    })
  }
}
